import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Immediately redirect to the target URL when the component mounts
    window.location.href = 'https://1millionpixelgrid.com/';
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 font-sans">
      <div className="text-center p-8 bg-white rounded-xl shadow-sm border border-gray-100 max-w-md w-full">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-gray-200 border-t-blue-600 mx-auto mb-6"></div>
        <h1 className="text-xl font-semibold text-gray-800 mb-2">Redirecting...</h1>
        <p className="text-gray-600 mb-6">Taking you to 1 Million Pixel Grid.</p>
        
        <p className="text-sm text-gray-500">
          If you are not redirected automatically,{' '}
          <a 
            href="https://1millionpixelgrid.com/" 
            className="text-blue-600 hover:text-blue-800 hover:underline font-medium"
          >
            click here
          </a>.
        </p>
      </div>
    </div>
  );
}

export default App;